import { render, staticRenderFns } from "./CalculationPercentage.vue?vue&type=template&id=48b0e446&"
import script from "./CalculationPercentage.vue?vue&type=script&lang=js&"
export * from "./CalculationPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports